import React, { useContext } from 'react'

import { NO_IMAGE_ICON } from '../../constants/urls'
import { DataContext } from '../../context/DataContext'
import { formatPrice } from '../../utils/string_util'

interface ProductCardProps {
  className?: string
}

const ProductCard: React.FC<ProductCardProps> = ({
  className = ''
}: ProductCardProps) => {
  const { sale: { shippingCost }, totalProducts: productsObject } = useContext(DataContext)

  if (productsObject === null || !productsObject.products) {
    return (
      <div className={className}>
        <div className="py-32 text-center">
          No hay productos que mostrar
        </div>
      </div>
    )
  }

  const { products } = productsObject
  const productsQuantity = () =>
    products.reduce(
      (quantity: number, nextProduct: Product) => quantity + nextProduct.quantity,
      0
    )

  return (
    <div className={className}>
      <div className='m-2'>
        <div className='flex portrait:flex-col font-[Geist] overflow-x-auto h-auto landscape:gap-8 portrait:gap-4 scrollbar-hide mb-4'>
          {
            products.map((product: Product) => (
              <div className="relative shrink-0 flex h-40 w-auto items-center py-4 gap-4 bg-[#F7F7F7] p-4 rounded-lg">
                <div className="h-32 w-[120px] shrink-0 overflow-hidden rounded">
                  <img
                    src={product.photoUrl && product.photoUrl[0] ? product.photoUrl[0].URLIMAGEN : NO_IMAGE_ICON}
                    alt=""
                    className="h-full w-full object-cover"
                  />
                </div>

                <div className='flex flex-col gap-2 justify-between h-full landscape:py-1 w-full'>
                  <p className='text-sm max-w-[150px]'>{product.productName}</p>

                  <div className='flex gap-2 justify-between items-center'>
                    <p className='text-xs text-gray-500 bg-white px-2 py-1 w-auto rounded-full'>Cantidad {product.quantity}</p>
                    <p className='text-sm text-gray-500'>${formatPrice(product.price)}</p>
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Product detail */}
        <div className='bg-[#F7F7F7] p-4 rounded-lg w-full'>
          <ul className="list-none m-0 text-base font-[Geist] w-8/12 min-w-[300px]">
            <li className='grid grid-cols-2'>
              <span className="font-medium">Total artículos </span>
              <p className='text-gray-500'>{productsQuantity()}</p>
            </li>
            <li className='grid grid-cols-2'>
              <span className="font-medium">Compra </span>
              <p className='text-gray-500'>${formatPrice(productsObject.totalProductsPrice)}</p>
            </li>
            {shippingCost && <li className='grid grid-cols-2'>
              <span className="font-medium">Envío </span>
                <p className='text-gray-500'>${formatPrice(shippingCost)}</p>
              </li>
            }
            <li className='grid grid-cols-2'>
              <span className="font-medium">Total compra </span>
              <p className='text-gray-500'>${formatPrice(productsObject.paidCost)}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
